import React from 'react'

import SearchField from '~/components/Fields/SearchField'
import * as API from '~/constants/api'

function CompanySearchField (props) {
  return (
    <SearchField
      api={API.UNIT_COMPANY_LIST}
      label="Company"
      name="company"
      data-cy="company"
      ListboxProps={{ 'data-cy': 'companyList' }}
      {...props}
    />
  )
}

export default CompanySearchField
